import { Text, View } from "react-native";
import { colors, radii } from "@louise/moon-ui/theme/tokens";

type CardField = {
  label: string;
  value: string;
};

type Props = {
  category: string;
  status: string;
  title: string;
  subtitle: string;
  fields: [CardField, CardField];
};

/**
 * A deliberately quiet, physical-card-inspired surface. Controls sit outside
 * of it so the card reads as a record rather than as a promotional tile.
 */
export default function CoverageCardSurface({
  category,
  status,
  title,
  subtitle,
  fields,
}: Props) {
  return (
    <View
      style={{
        width: "100%",
        aspectRatio: 1.58,
        borderRadius: radii.lg,
        backgroundColor: colors.deepBrown,
        padding: 20,
        justifyContent: "space-between",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <Text
          className="font-dm-sans"
          numberOfLines={1}
          style={{
            flex: 1,
            fontSize: 10,
            lineHeight: 13,
            fontWeight: "600",
            letterSpacing: 1.15,
            color: colors.warm,
            textTransform: "uppercase",
          }}
        >
          {category}
        </Text>
        <Text
          className="font-dm-sans"
          numberOfLines={1}
          style={{
            fontSize: 10,
            lineHeight: 13,
            fontWeight: "600",
            letterSpacing: 0.8,
            color: colors.warmLight,
            textTransform: "uppercase",
          }}
        >
          {status}
        </Text>
      </View>

      <View style={{ marginTop: 24, flex: 1, justifyContent: "center" }}>
        <Text
          className="font-dm-sans"
          numberOfLines={2}
          style={{
            fontSize: 22,
            lineHeight: 27,
            fontWeight: "500",
            letterSpacing: -0.35,
            color: colors.warmLight,
          }}
        >
          {title}
        </Text>
        <Text
          className="font-dm-sans"
          numberOfLines={1}
          style={{
            marginTop: 5,
            fontSize: 13,
            lineHeight: 18,
            color: colors.warm,
          }}
        >
          {subtitle}
        </Text>
      </View>

      <View style={{ flexDirection: "row", gap: 24 }}>
        {fields.map((field) => (
          <View key={field.label} style={{ flex: 1, minWidth: 0 }}>
            <Text
              className="font-dm-sans"
              numberOfLines={1}
              style={{
                fontSize: 9,
                lineHeight: 12,
                fontWeight: "600",
                letterSpacing: 0.8,
                color: colors.warm,
                textTransform: "uppercase",
              }}
            >
              {field.label}
            </Text>
            <Text
              className="font-dm-sans"
              numberOfLines={1}
              style={{
                marginTop: 4,
                fontSize: 14,
                lineHeight: 18,
                fontWeight: "500",
                color: colors.warmLight,
              }}
            >
              {field.value}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}
